import {create} from "@bufbuild/protobuf";
import {createClient} from "@connectrpc/connect";
import {apiTransport} from "../api/connectTransport";
import {FeedbackService, SendFeedbackRequestSchema} from "../gen/kitecorp/transferify/common/v1/feedback_pb";

/**
 * A user's support/feedback note plus an optional reply-to address, the fields of `SendFeedbackRequest`.
 *
 * The field name is `replyTo` (not `fromEmail`), as the legacy inline dialog named it (ui#149 was presentation-only).
 * `replyTo` is an empty string when the sender chose not to leave an address, and is sent as that empty string.
 */
export interface FeedbackRequest {
	message: string;
	replyTo: string;
}

/**
 * Support/Feedback service. Holds the single call the {@link useFeedback} hook drives, so the dialog view stays dumb
 * (epic #26).
 */
export class FeedbackApi {
	/**
	 * Sends the note through the feedback RPC on the api's transport, so a signed-in sender's bearer rides along. From
	 * kitecorp/transferify-api-service#3146 on, the api's `SendFeedback` adapter takes the optional caller from it to tag
	 * the note with their plan (api#217), while a visitor with no account is still served: the contact form is public.
	 * Resolves when the api accepted the note, rejects on any transport or api error.
	 */
	static async send(request: FeedbackRequest): Promise<void> {
		await createClient(FeedbackService, apiTransport).sendFeedback(create(SendFeedbackRequestSchema, request));
	}
}
